import {
  ActionBar,
  ActionBarMessage,
  Button,
  Link,
  Section,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { trackUserEvent } from '@vend/utilities'
import React, { useState } from 'react'
import { useCashMovementsManager } from '../../ng-compat/hooks'
import { wrToastNegative } from '../react/helios/ToastNotifications/WrToastNotifications'
import { WEB_REGISTER } from '../web-register.constant'
import { CashFloatForm } from './CashFloatForm'
import { CashFloatSettings, Movement } from './utils/types'

const RECORD_CASH_MOVEMENT_FAILED_TOAST_KEY = 'record.cash.movement.negative'
interface Props {
  onSuccess: (cashMovement: Movement) => void
}

export const SetRegisterCashFloat: React.FC<Props> = ({ onSuccess }) => {
  const cashMovementsManager = useCashMovementsManager()
  const [hasError, setHasError] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const handleOnError = (hasError: boolean) => setHasError(hasError)
  const onSubmitHandler = (settings: CashFloatSettings) => {
    setIsSaving(true)

    cashMovementsManager
      .recordCashMovement(settings)
      .then(cashMovement => {
        onSuccess(cashMovement as Movement)
      })
      .catch(() => {
        wrToastNegative(RECORD_CASH_MOVEMENT_FAILED_TOAST_KEY)
        trackUserEvent(WEB_REGISTER.DISPLAY_NAME, 'Cash Management', {
          'Failed Cash Float': true,
        })
      })
      .finally(() => {
        setIsSaving(false)
      })
  }

  return (
    <>
      <ActionBar variant="page">
        <ActionBarMessage>
          <T _str="Set opening cash drawer amount." _context="Action bar" />{' '}
          <Link
            href="https://support.vendhq.com/hc/en-us/articles/207884598-Cash-Management-in-Vend"
            isExternal
            isSecondary
          >
            <T _str="Need help?" />
          </Link>
        </ActionBarMessage>
      </ActionBar>
      <Section>
        <CashFloatForm onSubmit={onSubmitHandler} onError={handleOnError}>
          <div className="vd-button-group">
            <Button disabled={hasError} type="submit" loading={isSaving}>
              <T _str="Set float" _context="Button" />
            </Button>
          </div>
        </CashFloatForm>
      </Section>
    </>
  )
}
